(function () {
  'use strict';

  if (window.__botIngredientGuideReady) return;
  window.__botIngredientGuideReady = true;

  var previousFocus = null;
  var guideOpenPending = false;

  function getGuide() {
    return document.getElementById('BotIngredientGuide');
  }

  function hydrateGuide(guide) {
    if (!guide || guide.dataset.botGuideHydrated === 'true') return;
    var template = guide.querySelector('template[data-bot-guide-template]');
    if (template) {
      guide.appendChild(template.content.cloneNode(true));
      template.remove();
    }
    guide.dataset.botGuideHydrated = 'true';
  }

  function getFocusable(guide) {
    if (!guide) return [];
    return Array.prototype.slice.call(
      guide.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), summary, a[href], [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function revealGuide() {
    var guide = getGuide();
    guideOpenPending = false;
    if (!guide || !guide.hidden) return;

    hydrateGuide(guide);

    guide.hidden = false;
    guide.inert = false;
    guide.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bot-ingredient-guide-open');

    window.requestAnimationFrame(function () {
      var close = guide.querySelector('.bot-ingredient-guide__close');
      var search = guide.querySelector('[data-bot-guide-search]');
      var cards = guide.querySelectorAll('[data-bot-guide-card]');
      for (var i = 0; i < cards.length; i += 1) {
        cards[i].open = false;
      }
      if (search) search.value = '';
      if (search) filterCards(search);
      if (close) close.focus();
    });
  }

  function afterSheetCloses(sheetId, callback) {
    var completed = false;
    var safetyTimer = null;

    function finish() {
      if (completed) return;
      completed = true;
      document.removeEventListener('beauty:sheet-closed', onSheetClosed);
      if (safetyTimer) window.clearTimeout(safetyTimer);
      callback();
    }

    function onSheetClosed(event) {
      if (event.detail && event.detail.id === sheetId) finish();
    }

    document.addEventListener('beauty:sheet-closed', onSheetClosed);
    safetyTimer = window.setTimeout(finish, 1200);
  }

  function openGuide(trigger) {
    var guide = getGuide();
    if (!guide || !guide.hidden || guideOpenPending) return;

    var triggerInProfile = trigger && trigger.closest && trigger.closest('#shopModal3');
    previousFocus = triggerInProfile
      ? document.getElementById('shopBtn3')
      : (trigger || document.activeElement);

    var profile = document.getElementById('shopModal3');
    var profileClose = document.getElementById('closeModal3');
    if (triggerInProfile && profile && profile.classList.contains('open') && profileClose) {
      guideOpenPending = true;
      afterSheetCloses('shopModal3', revealGuide);
      profileClose.click();
      return;
    }

    revealGuide();
  }

  function closeGuide(restoreFocus) {
    var guide = getGuide();
    if (!guide || guide.hidden) return;

    guide.hidden = true;
    guide.inert = true;
    guide.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bot-ingredient-guide-open');
    guideOpenPending = false;

    if (restoreFocus !== false && previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
    previousFocus = null;
  }

  function filterCards(input) {
    var guide = input.closest('#BotIngredientGuide');
    if (!guide) return;

    var query = input.value.trim().toLowerCase();
    var cards = guide.querySelectorAll('[data-bot-guide-card]');
    var visible = 0;

    for (var i = 0; i < cards.length; i += 1) {
      var haystack = (cards[i].getAttribute('data-search') || '').toLowerCase();
      var show = !query || haystack.indexOf(query) !== -1;
      cards[i].hidden = !show;
      if (show) visible += 1;
    }

    var empty = guide.querySelector('[data-bot-guide-empty]');
    if (empty) empty.hidden = visible !== 0;

    var status = guide.querySelector('[data-bot-guide-status]');
    if (status) {
      status.textContent = visible === 1
        ? '1 ingredient shown.'
        : visible + ' ingredients shown.';
    }

    var filters = guide.querySelectorAll('[data-bot-guide-query]');
    for (var j = 0; j < filters.length; j += 1) {
      var filterQuery = (filters[j].getAttribute('data-bot-guide-query') || '').trim().toLowerCase();
      filters[j].setAttribute('aria-pressed', filterQuery === query ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest('#ingredientGuideBtn, [data-bot-guide-open]');
    if (opener) {
      event.preventDefault();
      openGuide(opener);
      return;
    }

    var filter = target.closest('[data-bot-guide-query]');
    if (filter) {
      event.preventDefault();
      var guide = filter.closest('#BotIngredientGuide');
      var search = guide && guide.querySelector('[data-bot-guide-search]');
      if (search) {
        search.value = filter.getAttribute('data-bot-guide-query') || '';
        filterCards(search);
      }
      return;
    }

    if (target.closest('[data-bot-guide-close]')) {
      event.preventDefault();
      closeGuide(true);
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target && event.target.matches('[data-bot-guide-search]')) {
      filterCards(event.target);
    }
  });

  document.addEventListener('toggle', function (event) {
    var card = event.target;
    if (!card || !card.matches || !card.matches('[data-bot-guide-card]') || !card.open) return;

    var guide = card.closest('#BotIngredientGuide');
    if (!guide) return;

    var openCards = guide.querySelectorAll('[data-bot-guide-card][open]');
    for (var i = 0; i < openCards.length; i += 1) {
      if (openCards[i] !== card) openCards[i].open = false;
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var guide = getGuide();
    if (!guide || guide.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeGuide(true);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusable(guide);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var current = document.activeElement;

    if (event.shiftKey && (current === first || !guide.contains(current))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (current === last || !guide.contains(current))) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#BotIngredientGuide')) {
      openGuide(null);
    }
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#BotIngredientGuide')) {
      closeGuide(false);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.closest || !block.closest('#BotIngredientGuide')) return;
    openGuide(null);
    if (block.tagName && block.tagName.toLowerCase() === 'details') {
      block.open = true;
      window.requestAnimationFrame(function () {
        block.scrollIntoView({ block: 'nearest' });
      });
    }
  });
})();
